import { Spin } from 'antd';
import AddIcon from '@mui/icons-material/Add';
import { useEffect, useMemo, useState } from 'react';
import SectionCard from 'components/section/SectionCard';
import ExpandingFab from './CustomComponents/ExpandingFab';
import { useLocation, useNavigate } from 'react-router-dom';
import SolutionCatalogIcon from 'assets/icons/solutions-catalog';
import AddNewVersionCard from './CustomComponents/AddNewVersionCard';
import LeavePolicyDetails from './CustomComponents/LeavePolicyDetails';
import { useSendControlDataMutation } from 'store/features/api/apiSlice';
import KeepMountedTabPanel from 'components/TabPanel/KeepMountedTabPanel';
import ComptrollerPageHeader from 'components/header/ComptrollerPageHeader';

const LeaveDetails = () => {
	const navigate = useNavigate();
	const [selectedTab, setSelectedTab] = useState(0);

	const { state } = useLocation();

	const [getSingleLeaveDetails, { data: leaveDetailsData, isUninitialized, isLoading, isSuccess }] = useSendControlDataMutation();

	const selectTabHandler = (event, newValue) => {
		setSelectedTab(newValue);
	};

	const TabsItem = useMemo(() => {
		const hasPastPolicies = leaveDetailsData?.responseData?.length > 1;

		return [{ label: 'Latest Policy', icon: 'active' }, ...(hasPastPolicies ? [{ label: 'Past Policies', icon: 'active' }] : [])];
	}, [leaveDetailsData]);
	console.log('TabsItem', TabsItem);

	const handleNewVersionCreation = (flag) => {
		if (flag === 'create') {
			navigate('/static/leave-combine/create', {
				state: { processCode: state?.processCode || '10127', data: state },
			});
		} else if (flag === 'update') {
			navigate('/static/leave-combine/update', {
				state: { processCode: state?.processCode || '10127', data: lastVersionData },
			});
		}
	};

	const lastVersionData = useMemo(() => {
		if (leaveDetailsData?.responseData?.length) {
			const detailsData = leaveDetailsData.responseData;
			return detailsData[detailsData.length - 1]?.data || {};
		}
		return {};
	}, [leaveDetailsData]);

	useEffect(() => {
		if (selectedTab >= TabsItem.length) {
			setSelectedTab(0);
		}
	}, [TabsItem, selectedTab]);

	useEffect(() => {
		if (state?.processCode && state?.leaveType) {
			const payload = {
				query: 'get-policy-by-type',
				leaveType: state?.leaveData?.leaveType?.toLowerCase(),
			};

			const jsonString = JSON.stringify(payload);

			const base64Data = btoa(jsonString);

			const formattedPayload = {
				data: base64Data,
				processCode: state?.processCode,
				scriptName: 'leave-controller',
				payload: payload,
			};
			getSingleLeaveDetails(formattedPayload);
		}
	}, [state]);

	return (
		<>
			<ComptrollerPageHeader
				createBtn={false}
				tabsItem={TabsItem}
				selectedTab={selectedTab}
				selectTabHandler={selectTabHandler}
				title={'View ' + state?.leaveType + ' Policy'}
				image={<SolutionCatalogIcon color="#fff" width="20px" height="20px" />}
			/>

			<KeepMountedTabPanel value={selectedTab} index={0} sx={{ height: 'calc(100% - 38px)' }}>
				{isLoading || isUninitialized ? (
					<SectionCard sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '300px' }}>
						<Spin size="large" />
					</SectionCard>
				) : lastVersionData && Object.keys(lastVersionData).length > 0 ? (
					<>
						<LeavePolicyDetails policyData={lastVersionData ?? {}} />
						<ExpandingFab icon={<AddIcon />} label="Revise Policy" color="primary" onClick={() => handleNewVersionCreation('update')} />
					</>
				) : (
					<AddNewVersionCard onClick={() => handleNewVersionCreation('create')} />
				)}
			</KeepMountedTabPanel>

			<KeepMountedTabPanel value={selectedTab} index={1}>
				{leaveDetailsData?.responseData?.slice(0, -1).map((item, index) => {
					return <LeavePolicyDetails key={index} title={`Version ${index + 1}`} policyData={item?.data} />;
				})}
			</KeepMountedTabPanel>
		</>
	);
};

export default LeaveDetails;
